/**
 *
 * PluginIcon
 *
 */

import React from 'react';
import Download from '@strapi/icons/Download';
const PluginIcon = () => /*#__PURE__*/React.createElement(Download, null);
export default PluginIcon;